import React from 'react'
import Support from '../Support'


const SupportPage = () => {
    return (
        <Support />
    )
}

export default SupportPage


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/SupportPage.js